import {Locales} from '@netx/core-next/locales/utils/Locales';
import {UserType} from './constants';

export const UserTypeLabel: Record<UserType, string> = Locales((i18n) => ({
	[UserType.IMPORTED_BY]: i18n('i18n.importedBy'),
	[UserType.MODIFIED_BY]: i18n('i18n.modifiedBy'),
}));
